// extracted by mini-css-extract-plugin
module.exports = {"button":"Costs_button__3c7Ra","container":"Costs_container__3hR5h","total":"Costs_total__jdYWm","rounding":"Costs_rounding__2QT3z"};